export default "__VITE_ASSET__CZG9cHpe__ 1250w";